import amplitudeEventNames from '@/consts/analytics/analyticsEventNames';
import analyticsEventProperties from '@/consts/analytics/analyticsEventProperties';
import analyticsEventValues from '@/consts/analytics/analyticsEventValues';

import amplitude from './amplitude';

const trackConsumerProfileScreen = () => {
    amplitude.trackWithSource(amplitudeEventNames.PROFILE_SCREEN_VIEWED);
};

const trackPreferenceCenterScreen = () => {
    amplitude.trackWithSource(amplitudeEventNames.PREFERENCE_CENTER_VIEWED);
};

const trackUpdateYourDataScreen = () => {
    amplitude.trackWithSource(amplitudeEventNames.PREFERENCE_CENTER_UPDATE_VIEWED);
};

const trackContactUsScreen = () => {
    amplitude.trackWithSource(amplitudeEventNames.CONTACT_US_VIEWED);
};

const trackShowProfileClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.SHOW_PROFILE_CLICKED);
};

const trackTermsOfUseClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.LEGAL_VIEWED, {
        [analyticsEventProperties.LEGAL]: analyticsEventValues.TERMS_OF_USE,
    });
};

const trackPrivacyNoticeClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.LEGAL_VIEWED, {
        [analyticsEventProperties.LEGAL]: analyticsEventValues.PRIVACY_NOTICE,
    });
};

const trackAttributionNoticeClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.LEGAL_VIEWED, {
        [analyticsEventProperties.LEGAL]: analyticsEventValues.ATTRIBUTION_NOTICE,
    });
};

const trackLogOutClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.LOG_OUT);
};

export default {
    trackConsumerProfileScreen,
    trackPreferenceCenterScreen,
    trackUpdateYourDataScreen,
    trackContactUsScreen,
    trackShowProfileClick,
    trackTermsOfUseClick,
    trackPrivacyNoticeClick,
    trackAttributionNoticeClick,
    trackLogOutClick,
};
